var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImgDocReject = function SvgImgDocReject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 210,
    viewBox: "0 0 177 210",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.278 189.179L67.5932 210C51.6149 162.65 42.2009 112.626 38.8794 60.1023L147.564 39.2815C148.403 89.3756 158.7 139.33 176.278 189.179Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.386 42.9527L131.988 42.2622L117.548 175.893L54.351 164.11L53.136 158.979L128.386 42.9527Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 167.554L0 150.885C14.7371 101.665 22.4029 51.3702 22.9973 0L132.398 16.6776C129.453 66.7193 121.542 117.023 109.401 167.554Z",
    fill: "#BDBDBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8195 60.9852L41.1084 47.7777L44.6222 45.1904L51.7461 54.8753L76.4216 36.7292L79.0177 40.2518L50.8195 60.9852Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0871 85.4423L37.376 72.2348L40.8986 69.6475L48.0224 79.3324L72.6979 61.1863L75.2852 64.7089L47.0871 85.4423Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgDocReject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/img_doc_reject.b801611b.svg";
export { ForwardRef as ReactComponent };